export function isKit(product: any) {
  // https://partsavatar.ca/centric-parts-front-disc-brake-upgrade-kit-907-42026
  // https://partsavatar.ca/front-brake-kit
  const { extendedDescription } = product || {};
  if (extendedDescription && extendedDescription.components && Array.isArray(extendedDescription.components) && extendedDescription.components.length) {
    return true;
  }
  return false;
}

export const hasKitSpecifications = (product) => {
  const { extendedDescription } = product || {};
  const { components } = extendedDescription;
  const result = components.some((component) => {
    const { extendedDescription: componentExtendedDescription } = component;
    const { specifications, ...restDescription } = componentExtendedDescription || {};
    return specifications?.[0] || Object.keys(restDescription).length > 0;
  });
  return result;
};
